import { Component, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { LocalTimePoint } from "shared-lib";
import { Filter } from "@admin_app/storage/paypal-sftp-files/paypal-sftp-files.state";
import { ReportFileStatusEnum } from "@admin_api/models/report-file-status-enum";
import { ReportFileTypeEnum } from "@admin_api/models/report-file-type-enum";

@Component({
    selector: "app-paypal-sftp-log-filters",
    templateUrl: "./paypal-sftp-log-filters.component.html",
    styleUrls: ["./paypal-sftp-log-filters.component.less"],
    standalone: false
})
export class PayPalSftpLogFiltersComponent {

    @Output() filterChanged = new EventEmitter<Filter>();
    @Input() filter: Filter;

    LocalTimePoint = LocalTimePoint;

    fileTypeList: Array<ReportFileTypeEnum>;
    fileStatusList: Array<ReportFileStatusEnum>;

    constructor(
        private fb: UntypedFormBuilder
    ) {
        this.fileTypeList = Object.values(ReportFileTypeEnum);
        this.fileStatusList = Object.values(ReportFileStatusEnum);
    }

    filterForm = this.fb.group({
        localDateInterval: [null],
        types: [null],
        statuses: [null]
    });

    onFilterChanged(filter: Filter) {
        this.filterChanged.emit(filter);
    }

}
